<template>
  <div>
    <h1 class="mb-6">Angebote für Geschäftskunden</h1>

    <section class="bg-grey-lightest p-4 rounded border-l-4 border-green-heinz ">
        <h2 class="border-0 text-xl">Gutscheine als steuerfreier Sachbezug für eure Mitarbeiter</h2>
        Wir bieten euch ein automatisiertes System, welches jedem gewünschten Mitarbeiter monatlich einen
        Gutscheincode im Wert von bis zu 50 € zusendet. Löst der Mitarbeiter ihn innerhalb des Monats ein, stellen wir euch den Betrag gesammelt
        in Rechnung. Löst er ihn nicht ein, verfällt er und ihr müsst nichts zahlen. Es gibt keine zusätzlichen
        Kosten.<br />
        <br />
        Alles, was wir dazu von euch benötigen:<br />

        <ul style="list-style-type: none;">
            <li><template v-if="isLoggedIn">✅</template><template v-else>⭕️</template> Angemeldeter Nutzeraccount</li>
            <li><template v-if="hasSepa">✅</template><template v-else>⭕️</template> Hinterlegtes <a href="#" @click="openSepa()" class="text-green-darker font-bold">SEPA Mandat</a> für die Abrechnung</li>
            <li><template v-if="sepaApproved === 'Y'">✅</template><template v-else>⭕️</template> Geprüftes und freigeschaltetes <a href="#" @click="openSepa()" class="text-green-darker font-bold">SEPA Mandat</a> für die Abrechnung</li>
            <li><template v-if="hasReceivers">✅</template><template v-else>⭕️</template> E-Mail Adressen der Mitarbeiter, die monatlich Gutscheine erhalten sollen</li>
        </ul>
        <input v-if="!isLoggedIn" type="button" @click="userLogin()" class="mt-4 bg-green-heinz text-black py-3 px-2 mb-2 rounded cursor-pointer" value="Anmelden" />
    </section>

    <div v-if="isLoggedIn && hasSepa" class="mt-12">
        <h1 class="mb-6">Mitarbeiter verwalten</h1>

        <button v-on:click="addReceiverModal()" class="inline-block text-xs font-semibold rounded-full px-4 py-1 mb-1 leading-normal bg-green-heinz border border-green-heinz text-black hover:bg-white hover:text-green-heinz hover:border-green-heinz">
            Mitarbeiter hinzufügen
        </button>

        <table v-if="hasReceivers" class="w-full mt-8">
            <thead>
                <th class="text-left p-2">Angelegt</th>
                <th class="text-left p-2">Vorname</th>
                <th class="text-left p-2">E-Mail Adresse</th>
                <th class="text-left p-2">Budget</th>
                <th class="text-left p-2">Gutscheine</th>
                <th class="text-right p-2">Optionen</th>
            </thead>
            <tbody>
                <tr v-for="receiver in receivers" :key="receiver.id" :class="{ 'text-grey': receiver.item_active === 'N' }">
                    <td class="text-left p-2">{{ receiver.item_created }}</td>
                    <td class="text-left p-2">{{ receiver.item_firstname }}</td>
                    <td class="text-left p-2">{{ receiver.item_email }}</td>
                    <td class="text-left p-2">{{ receiver.item_budget }} €</td>
                    <td class="text-left p-2">{{ receiver.item_coupon_count }}</td>
                    <td class="text-right p-2">
                        <button v-on:click="editReceiver(receiver)" class="inline-block text-xs font-semibold rounded-full px-4 py-1 mb-1 leading-normal bg-green-heinz border border-green-heinz text-black hover:bg-black hover:text-green-heinz hover:border-green-heinz">
                            bearbeiten
                        </button>
                        <button v-on:click="toggleReceiver(receiver, (receiver.item_active === 'Y' ? 'N' : 'Y'))" class="inline-block text-xs font-semibold rounded-full px-4 py-1 mb-1 leading-normal bg-green-heinz border border-green-heinz text-black hover:bg-black hover:text-green-heinz hover:border-green-heinz">
                            <template v-if="receiver.item_active === 'Y'">de</template>aktivieren
                        </button>
                        <button v-on:click="removeReceiver(receiver)" class="inline-block text-xs font-semibold rounded-full px-4 py-1 mb-1 leading-normal bg-green-heinz border border-green-heinz text-black hover:bg-black hover:text-green-heinz hover:border-green-heinz">
                            löschen
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <dialog class="z-50 add-reciever-dialog" name="addReceiver" id="add-reciever-dialog" height="auto">
      <div class="dialog__content">
        <h3 class="headline-extras">Mitarbeiter hinzufügen</h3>
        <form class="w-full" onsubmit="return false;">
          <div class="md:flex md:items-center mb-6">
              <div class="md:w-1/3">
              <label class="block text-grey-darker font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-full-name">
                  Vorname
              </label>
              </div>
              <div class="md:w-2/3">
                  <input type="text" v-model="receiverFirstname" class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" />
              </div>
          </div>
          <div class="md:flex md:items-center mb-6">
              <div class="md:w-1/3">
              <label class="block text-grey-darker font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-full-name">
                  E-Mail Adresse
              </label>
              </div>
              <div class="md:w-2/3">
                  <input type="email" v-model="receiverEmail" class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" />
              </div>
          </div>
          <div class="md:flex md:items-center mb-6">
              <div class="md:w-1/3">
              <label class="block text-grey-darker font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-full-name">
                  Monatliches Budget
              </label>
              </div>
              <div class="md:w-2/3">
                  <input type="number" min="1" max="50" step="1"  v-model="receiverBudget" class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" />
              </div>
          </div>
          <div class="md:flex md:items-center">
              <div class="md:w-1/3">
                  <button @click="closeDialog('add-receiver-dialog')" class="shadow bg-grey hover:bg-grey-light text-white font-bold py-2 px-4 rounded cursor-pointer" type="button">
                      abbrechen
                  </button>
              </div>
              <div class="md:w-2/3 text-right">
                  <button @click.prevent="addReceiver" class="shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold py-2 px-4 rounded cursor-pointer" type="button">
                      Weiter!
                  </button>
              </div>
          </div>
        </form>
      </div>
    </dialog>

    <dialog class="z-50 edit-reciever-dialog" name="editReceiver" id="edit-reciever-dialog" height="auto">
      <div class="dialog__content">
        <h3 class="headline-extras">Mitarbeiter bearbiten</h3>
        <form class="w-full" onsubmit="return false;">
          <div class="md:flex md:items-center mb-6" style="opacity:0.5;">
              <div class="md:w-1/3">
              <label class="block text-grey-darker font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-full-name">
                  Vorname
              </label>
              </div>
              <div class="md:w-2/3">
                  <input type="text" v-model="receiverFirstname" disabled class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" />
              </div>
          </div>
          <div class="md:flex md:items-center mb-6" style="opacity:0.5;">
              <div class="md:w-1/3">
              <label class="block text-grey-darker font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-full-name">
                  E-Mail Adresse
              </label>
              </div>
              <div class="md:w-2/3">
                  <input type="email" v-model="receiverEmail" disabled class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" />
              </div>
          </div>
          <div class="md:flex md:items-center mb-6">
              <div class="md:w-1/3">
              <label class="block text-grey-darker font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-full-name">
                  Monatliches Budget
              </label>
              </div>
              <div class="md:w-2/3">
                  <input type="number" min="1" max="50" step="1" v-model="receiverBudget" class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" />
              </div>
          </div>
          <div class="md:flex md:items-center">
              <div class="md:w-1/3">
                  <button @click="closeDialog('edit-receiver-dialog')" class="shadow bg-grey hover:bg-grey-light text-white font-bold py-2 px-4 rounded cursor-pointer" type="button">
                      abbrechen
                  </button>
              </div>
              <div class="md:w-2/3 text-right">
                  <button @click.prevent="updateReceiver" class="shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold py-2 px-4 rounded cursor-pointer" type="button">
                      Weiter!
                  </button>
              </div>
          </div>
        </form>
      </div>
    </dialog>

    <dialog adaptive class="z-50 sepa-mandate-dialog" name="sepaMandate" height="auto" id="sepa-mandate-dialog">
      <div class="dialog__content">
        <h3 class="headline-extras">SEPA Mandat erteilen</h3>

        <section v-if="sepaApproved === 'Y'" class="bg-grey-lighter p-4 mb-6 rounded border-l-4 border-green-heinz ">
            <strong>ACHTUNG!</strong> Du hast bereits ein freigeschaltetes SEPA Mandat. Wenn du etwas änderst, muss es erneut freigegeben werden (i.d.R. innerhalb von 24 Stunden). In der Zwischenzeit können keine Gutscheine erstellt oder eingelöst werden.
        </section>

        <form class="w-full" ref="sepaForm" v-on:submit.prevent="updateSepa">
        <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
            <label class="block text-grey-darker font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-sepaCompany">
                Firma/Kontoinhaber
            </label>
            </div>
            <div class="md:w-2/3">
                <input type="text" id="inline-sepaCompany" v-model="sepaCompany" required class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" />
            </div>
        </div>
        <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
            <label class="block text-grey-darker font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-sepaStreet">
                Straße/Hausnr.
            </label>
            </div>
            <div class="md:w-2/3">
                <input id="inline-sepaStreet" type="text" v-model="sepaStreet" required class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" />
            </div>
        </div>
        <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
            <label class="block text-grey-darker font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-sepaCity">
                PLZ/Ort
            </label>
            </div>
            <div class="md:w-2/3">
                <input id="inline-sepaCity" type="text" v-model="sepaCity" required class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" />
            </div>
        </div>
        <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
            <label class="block text-grey-darker font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-sepaIban">
                IBAN
            </label>
            </div>
            <div class="md:w-2/3">
                <input id="inline-sepaIban" type="text" v-model="sepaIban" required class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" />
            </div>
        </div>
        <div class="md:flex md:items-center mb-6">
            <div>
                <label>
                    <input type="checkbox" v-model="sepaSign"  />
                    Hiermit bestätige ich, dass ich vertretungsberichtigt bin und erteile das SEPA Lastschriftmandat zum Einzug aller im Zusammenhang der Mitarbeiter-Gutscheine entstehenden Kosten.
                </label>
            </div>
        </div>
        <div class="md:flex md:items-center">
            <div class="md:w-1/3">
                <button @click="closeDialog('sepa-mandate-dialog')" class="shadow bg-grey hover:bg-grey-light text-black font-bold py-2 px-4 rounded" type="button">
                    abbrechen
                </button>
            </div>
            <div class="md:w-2/3 text-right">
                <input type="submit" value="Mandat erteilen" class="bg-green-heinz hover:bg-green-heinz-light text-black hover:text-black py-4 px-2 mb-8 w-full rounded hover:cursor-pointer" />
            </div>
        </div>
        </form>
      </div>
    </dialog>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import endpoints from '../../endpoints'
import axios from 'axios'
import { openDialog, closeDialog } from '../../utils/dialog'

export default {
  name: 'usersettings',

  data () {
    return {
      receivers: [],
      receiverFirstname: '',
      receiverEmail: '',
      receiverBudget: 50,
      receiverId: 0,
      sepaCompany: '',
      sepaStreet: '',
      sepaCity: '',
      sepaIban: '',
      sepaSign: false,
      sepaApproved: 'N'
    }
  },

  computed: {
    ...mapGetters([
      'isLoggedIn'
    ]),

    hasReceivers () {
      return this.receivers.length > 0
    },

    hasSepa () {
      return (this.sepaIban && this.sepaIban.length > 10)
    }
  },

  created () {
    this.load()
    this.loadSepa()
  },

  methods: {
    closeDialog,
    userLogin () {
      this.$parent.userLogin()
    },

    load () {
      axios.post(endpoints.businessEmployees).then(response => {
        this.receivers = response.data.receivers
      })
    },

    loadSepa () {
      axios.post(endpoints.businessCustomerSepa).then(response => {
        this.sepaApproved = response.data.sepa.item_sepa_approved
        this.sepaIban = response.data.sepa.item_sepa_iban
        this.sepaCompany = response.data.sepa.item_sepa_name
        this.sepaStreet = response.data.sepa.item_sepa_street
        this.sepaCity = response.data.sepa.item_sepa_city
      })
    },

    toggleReceiver (receiver, status) {
      axios.post(endpoints.businessEmployeesToggleStatus, {
        'id': receiver.id,
        'status': status
      }).then(response => {
        this.load()
      })
    },

    removeReceiver (receiver) {
      if (confirm('Mitarbeiter wirklich endgültig löschen? Zugehörige Gutscheine werden damit ebenfalls deaktiviert.')) {
        axios.post(endpoints.businessEmployeesRemoveReceiver, {
          'id': receiver.id
        }).then(response => {
          if (response.data.success) {
            this.load()
          } else {
            alert(response.data.errors[0])
          }
        })
      }
    },

    addReceiverModal () {
      this.receiverId = 0
      this.receiverFirstname = ''
      this.receiverEmail = ''
      this.receiverBudget = 50
      openDialog('add-reciever-dialog')
    },

    addReceiver () {
      closeDialog('add-reciever-dialog')

      axios.post(endpoints.businessAddReceiver, {
        'item_firstname': this.receiverFirstname,
        'item_email': this.receiverEmail,
        'item_budget': this.receiverBudget
      }).then(response => {
        if (response.data.success) {
          this.receiverEmail = ''
          this.load()
        } else {
          alert(response.data.errors[0])
        }
      })
    },

    editReceiver (reciver) {
      this.receiverId = reciver.id
      this.receiverFirstname = reciver.item_firstname
      this.receiverEmail = reciver.item_email
      this.receiverBudget = reciver.item_budget
      openDialog('edit-reciever-dialog')
    },

    updateReceiver (event) {
      if (event) event.preventDefault()

      axios.post(endpoints.businessEditReceiver, {
        'id': this.receiverId,
        'item_firstname': this.receiverFirstname,
        'item_email': this.receiverEmail,
        'item_budget': this.receiverBudget
      }).then(response => {
        if (response.data.success) {
          closeDialog('edit-reciever-dialog')
          this.load()
        } else {
          alert(response.data.messages[0])
        }
      })
    },

    openSepa () {
      openDialog('sepa-mandate-dialog')
    },

    updateSepa (event) {
      if (event) event.preventDefault()

      axios.post(endpoints.updateBusinessCustomerSepa, {
        'item_sepa_iban': this.sepaIban,
        'item_sepa_name': this.sepaCompany,
        'item_sepa_street': this.sepaStreet,
        'item_sepa_city': this.sepaCity,
        'sepaSign': this.sepaSign
      }).then(response => {
        if (response.data.success) {
          closeDialog('sepa-mandate-dialog')
          this.loadSepa()
          alert('Die Änderungen wurden gespeichert. Wir prüfen das SEPA Mandat innerhalb von 24 Stunden.')
        } else {
          alert(response.data.messages[0])
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  tbody {
    tr:nth-child(even) {
      td {
        @apply bg-grey-light;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/business.vue